import { ref } from '@/composition/vue/compositionApi'

const isFeatureTooltipWasShown = ref(false)

export const useFeatureTooltipWasShown = () => {
  return {
    isFeatureTooltipWasShown,
  }
}
